import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogsicon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 18,
	viewBox: "0 0 21 18",
	fill: "#fff",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6697",
		"data-name": "Path 6697",
		d: "M13,3a9,9,0,0,0-9,9H1l3.89,3.89.07.14L9,12H6a7.034,7.034,0,1,1,2.06,4.94L6.64,18.36A9,9,0,1,0,13,3ZM12,8v5l4.25,2.52.77-1.28L13.5,12.15V8Z",
		transform: "translate(-1 -3)"
	})
});
export { SvgLogsicon as ReactComponent };
